export default __webpack_public_path__ + "static/media/file-upload-helper-text.6f529d5e.svg";